export default __webpack_public_path__ + "static/media/ic_wftm_24.c2866f32.svg";